import React from 'react';
import '../../styles/Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <div className="app-footer-brand">
        <span className="app-footer-name">Boxed</span>
        <span className="app-footer-sep" aria-hidden="true">
          ·
        </span>
        <span className="app-footer-company">Provision Global Solutions</span>
      </div>
      <p className="app-footer-copy">
        © {year} Provision Global Solutions. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
